import ImageCircularAvatar from '@/components/UI/Avatar/ImageCircularAvatar';
import type { User } from '@/types/User';
import { getInitials } from '@/utils';

const DrawApprovers = ({ invoiceApprovers, documentApprovers }: { invoiceApprovers: User[]; documentApprovers: User[] }) => {
  return (
    <div className='w-full grid grid-cols-2 border-t-2 py-8'>
      <div className='col-span-1 flex items-center gap-3'>
        <h4 className='font-semibold'>Invoice Approvers:</h4>
        <div className='flex -space-x-3'>
          {invoiceApprovers.map((approver) => (
            <ImageCircularAvatar
              key={approver?.id}
              customClass='h-8 w-8 ring-2 ring-white dark:ring-neutral-900'
              imageUrl={approver?.profileImageUrl as string}
              fallbackText={approver?.name && getInitials(approver?.name)}
            />
          ))}
        </div>
      </div>
      <div className='col-span-1 flex items-center gap-3'>
        <h4 className='font-semibold'>Document Approvers:</h4>
        <div className='flex -space-x-4'>
          {documentApprovers.map((approver) => (
            <ImageCircularAvatar
              key={approver?.id}
              customClass='h-8 w-8 ring-2 ring-white dark:ring-neutral-900'
              imageUrl={approver?.profileImageUrl as string}
              fallbackText={approver?.name && getInitials(approver?.name)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DrawApprovers;
